"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventType = void 0;
// this is a 'const enum' copy of eventType from '@atlassiansox/analytics-web-client'
// exporting it here allows importing the enum directly from this package - it cannot be directly exported, as
// enums have issues being accessed during runtime from *.d.ts files
// https://stackoverflow.com/a/50511773
// https://stackoverflow.com/a/66939542
var eventType = exports.eventType = /*#__PURE__*/function (eventType) {
  eventType["TRACK"] = "track";
  eventType["UI"] = "ui";
  eventType["OPERATIONAL"] = "operational";
  eventType["SCREEN"] = "screen";
  eventType["IDENTIFY"] = "identify";
  return eventType;
}({});